import {Category} from "./types";

import BreakfastPancakes from './BreakfastPancakes'
import BreakfastMeals from "./BreakfastMeals";
import ChickenMeals from "./ChickenMeals";
import SteakAndBeef from "./Steak & Beef";
import PorkHub from "./PorkHub";
import Fish from "./Fish";
import Salad from "./Salad";

const foods: Category = {
    "Breakfast Pancakes": BreakfastPancakes,
    "Breakfast Meals": BreakfastMeals,
    "Chicken Meals": ChickenMeals,
    "Steak & Beef": SteakAndBeef,
    "PorkHub": PorkHub,
    "Fish": Fish,
    "Salad": Salad
}

export default foods